import HeadLine from '../../HeadLine/HeadLine';
import { ReactComponent as GHSvg } from '../../Img/githubCnt.svg';
import { ReactComponent as LnkdSvg } from '../../Img/linkdin.svg';
import { ReactComponent as PhnSvg } from '../../Img/phone.svg';
import { ReactComponent as EmlSvg } from '../../Img/email.svg';
import { ReactComponent as MailPng } from '../../Img/email2.svg';

import './ContactPage.css'
import '../../variable.css'
let Contact = () => {
    return (
        <div id='contact'>
            <div>
                <HeadLine text='Contact' index='5' />
            </div>
            <div>
                <div className='contact-links' >
                    <div></div>
                    <div>
                        <a href='https://github.com/pratap562' target='_blank' rel="noreferrer" >
                            <div>
                                <GHSvg className='github-contact-logo'></GHSvg>
                                <div id='contact-github'>GithHub</div>
                            </div>
                        </a>
                        <a href='https://www.linkedin.com/in/pratap-686a1a214/' target='_blank' rel="noreferrer" >
                            <div>
                                <LnkdSvg></LnkdSvg>
                                <div id='contact-linkedin'>Linkedin</div>
                            </div>
                        </a>
                        <a>
                            <div>
                                <PhnSvg></PhnSvg>
                                <div id='contact-phone'>9958902463</div>
                            </div>
                        </a>
                        <a>
                            <div>
                                <MailPng></MailPng>
                                <div id='contact-email'>kumpratap562@gmail.com</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact